import React, { useEffect, useState } from "react";
import VirtualTable from "../ui/VirtualTable";
import Space from "../ui/Space";
import Label from "../ui/Label";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import { ageInDays, bm_date, centsToPrice } from "../utils/Utils";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Nav from "../ui/Nav";
import Spin from "../ui/Spin";
import { ROUTES } from "../utils/Routes";
import { createModal } from "../hooks/createModal";
import CustomerARTotal from "./CustomerARTotal";

export default function CustomerAR(props) {

    const { route = "", drawExtra = () => { }, switchView = () => { } } = props;
    const customer = props.selected;
    const { ship_to = "" } = customer;
    const [loading, setLoading] = useState(false);
    const [align, setAlign] = useState("start");
    const [filters, setFilters] = useState({ limit: 40, sort: "invoice" })
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});

    const buffer = 20;
    const row_key = "id";

    const ar_nav = [

        { text: "Delete" },
        { text: "Edit" },
        { text: "Filter" },
        { text: "List" },
        { text: "Mark" },
        { text: "New" },
        { text: "Print" },
        { text: "Search" },
        { key: KBD.T, text: "Total", action: () => { fetchTotal() } },
        { text: "Ctrl+Transfer", inds: [0, 1, 2, 3, 4, 5] },
        { text: "Undo" },
        { key: KBD.ESCAPE, action: () => { switchView("customers") } },


    ]

    useEffect(() => {
        const cleanup = listen(route, ar_nav);
        return cleanup;
    }, [ar_nav])


    const fetchTotal = () => {
       window.bm_state.value = ROUTES.CUSTOMER.AR_TOTAL; 
       createModal({ component: <CustomerARTotal ship_to={ship_to} route={ROUTES.CUSTOMER.AR_TOTAL} />, closable: true, title: "Total Outstanding", callback: () => { window.bm_state.value = ROUTES.CUSTOMER.AR; } })
    }


    const fetch = () => {
        if (loading) { return }
        setLoading(true);
        let _filters = { ...filters };
        _filters.ship_to = ship_to;
        pubCall("account_receivable.getCustomerInitial", _filters, (_s, _r) => {
            if (_s) {
                if (_r.rows_previous.length > 0) {
                    setAlign("start");
                }
                setData(_r.rows_previous.concat(_r.rows_next));
                setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    useEffect(fetch, []);



    const fetchNext = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("account_receivable.getCustomerNext", { ...filters, "limit": 20, "acr_id": data[data.length - 1]?.id, ship_to: ship_to }, (_s, _r) => {
            if (_s) {
                setData([...data.concat(_r)]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    const fetchPrev = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("account_receivable.getCustomerPrevious", { ...filters, "limit": 20, "acr_id": data[0]?.id, ship_to: ship_to }, (_s, _r) => {
            if (_s) {
                setAlign("start");
                setData([..._r.concat([...data])]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");

        const nextIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        // Fetch chunk...

        if (nextIndex > data.length - buffer) {
            if (!loading) {
                fetchNext(true);
            }
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) - _rows;


        if (prevIndex < 2) {
            if (!loading) {
                fetchPrev(true);
            }
        }

        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };



    const columns = [
        { key: "type", title: <>Type</>, align: "left", width: 100 },
        { key: "invoice", title: <>Invoice #</>, align: "left", width: 100 },
        {
            key: "date", title: <>Invoice Date</>, align: "left", width: 100, render: (e) => {
                return (e) ? bm_date(e / 1000) : "";
            }
        },
        {
            key: "age", title: <>Age</>, width: 60, render: (e, f) => {
                return (f.date) ? ageInDays(f.date) : ""
            }
        },
        { key: "purchase_order", title: <>PO#Reference</>, align: "left", width: 105 },
        {
            key: "amount_due_cents", title: <>Amount Due</>, width: 90, render: (e) => {
                return centsToPrice(e);
            }
        },
        { key: "reconcile", title: <>Rec#</>, width: 40 },
        { key: "note", title: <>Notes</>, align: "left", width: 100, grow: true },
        { key: "ship_to", title: <>Ship To</>, align: "left", width: 80 }
    ]

    return (
        <Spin>
            <Space style={{ "padding": "5px 20px" }}>
                <Label>&nbsp;</Label>
            </Space>

            <Space grow style={{ "alignItems": "flex-start", "padding": "0px 15px" }} size={15}>
                <VirtualTable
                    header={<Label className="light" style={{"textAlign" : "left"}}>AR Invoices & History</Label>}
                    headerClass="danger"
                    onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                    next={next}
                    prev={prev}
                    align={align}
                    row_key={row_key}
                    current={selected}
                    data={data}
                    columns={columns}
                    width={960}
                    loading={false}
                    offset={430}
                    route={route}
                />
                {drawExtra()}
            </Space>

            <div style={{ "marginLeft": "15px", "position": "absolute", "marginTop": "15px" }}><Nav nav={ar_nav} /></div>
        </Spin>
    )


    //  <div style={{ 'height': "30px" }}>
    //                 {(state.view === "customers" &&
    //                     <Space style={{ "padding": "0px 15px" }}>
    //                         <Nav nav={customers_nav} />
    //                     </Space>
    //                 )}
    //             </div>



}